import * as React from "react";
import { Link } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import * as i18next from "i18next"; // traduction
// import * as Enums from '@tunnel-enums/index';
// import * as Utils from '@Cyclope-Utils/index';
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { Elem } = props;
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  // const User : any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  // const authorization : boolean = Utils.simpleAuthorizationIsAllowed(User,[Enums.AuthorizationRightsEnums.SYSTEMUPDATEDTUBES])  ;
  //
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <Styled.HorrizontalDisplayContainer
      isVisible={true}
      style={{ width: "100%", marginBottom: "15px", position: "relative" }}
    >
      <div className="systemContentInformation">
        {Elem.color && (
          <div
            className="sectionColor"
            style={{ backgroundColor: Elem.color.rgbString }}
          />
        )}
      </div>
      <div className="systemContentInformation">
        <span className="sectionName">{Elem.name}</span>
      </div>
      <div className="systemContentInformation">
        <span
          className="sectionType"
          style={{ fontSize: "14px", color: "black" }}
        >
          {Elem.sectionType && Elem.sectionType.name}
        </span>
      </div>
      <div className="systemContentInformation">
        <Link
          to={`${Paths.PathsNamesEnums.SYSTEMSCONFIG}${Elem.id}`}
          className="btnPrimary "
          style={{
            overflow: "visible",
            padding: "10px 20px",
            textDecoration: "none",
          }}
        >
          {i18next.t("acceder")}
        </Link>
      </div>
    </Styled.HorrizontalDisplayContainer>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  Elem?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/system/home/component.tsx